import { getDndAreaElement, getGridNodeElement } from './domSelectors';
import { forEachTree, iterateFrom } from 'layout-data-lib/GridLayoutDataTree/utils';
import { createDndAreaContainerElement, createDndAreaModuleElement, createDndAreaSectionElement } from './renderNodes';
import { DND_GRID_AREA_BACKGROUND_CLASS_NAME } from './constants';
const DOM_LOOKUP_MAP = {};
function getElementFromExistingDomLookup(treeId, id) {
  const lookupForTree = DOM_LOOKUP_MAP[treeId];
  if (lookupForTree) {
    const result = lookupForTree[id];
    delete lookupForTree[id];
    return result;
  }
  return null;
}
function findOrCreateDndAreaElement(gridNode) {
  let element;
  if (gridNode.isSection()) {
    var _getElementFromExisti;
    element = (_getElementFromExisti = getElementFromExistingDomLookup(gridNode.getRootId(), gridNode.getId())) !== null && _getElementFromExisti !== void 0 ? _getElementFromExisti : createDndAreaSectionElement(gridNode);
    const sectionContentElement = element.lastElementChild;
    if (!sectionContentElement) {
      throw new Error('Section content element not found');
    }
    stripChildrenFromTreeNode(sectionContentElement, gridNode);
  } else if (gridNode.isContainer()) {
    var _getElementFromExisti2;
    element = (_getElementFromExisti2 = getElementFromExistingDomLookup(gridNode.getRootId(), gridNode.getId())) !== null && _getElementFromExisti2 !== void 0 ? _getElementFromExisti2 : createDndAreaContainerElement(gridNode);
    element = stripChildrenFromTreeNode(element, gridNode);
  } else {
    var _getElementFromExisti3;
    element = (_getElementFromExisti3 = getElementFromExistingDomLookup(gridNode.getRootId(), gridNode.getId())) !== null && _getElementFromExisti3 !== void 0 ? _getElementFromExisti3 : createDndAreaModuleElement(gridNode);
    element = stripChildrenFromTreeNode(element, gridNode);
  }
  return element;
}

/**
 * Strips the children of a node if it contains sections, containers, or modules
 * @param element
 * @param node
 * @returns
 */
function stripChildrenFromTreeNode(element, node) {
  var _backgroundLayersCont;
  if (node.isModule()) {
    return element;
  }
  let backgroundLayersContainer;
  for (let i = 0; i < element.children.length; i++) {
    if (element.children[i].classList.contains(DND_GRID_AREA_BACKGROUND_CLASS_NAME)) {
      backgroundLayersContainer = element.children[i];
      break;
    }
  }
  element.replaceChildren((_backgroundLayersCont = backgroundLayersContainer) !== null && _backgroundLayersCont !== void 0 ? _backgroundLayersCont : '');
  return element;
}
function addTreeElementsToLookupMap(treeId, treeRootNode) {
  iterateFrom(treeRootNode, {
    gridNodeCallback: ({
      gridNode,
      parentNode
    }) => {
      let element;
      if (gridNode.isRoot()) {
        element = getDndAreaElement(gridNode.getId());
      } else {
        const parentElement = DOM_LOOKUP_MAP[treeId][parentNode.getId()];
        element = getGridNodeElement(gridNode, parentElement !== null && parentElement !== void 0 ? parentElement : undefined);
      }
      DOM_LOOKUP_MAP[treeId][gridNode.getId()] = element;
    }
  });
}
function renderGridNodes(gridNode, parentElement, config) {
  if (gridNode.isContainer()) {
    const element = findOrCreateDndAreaElement(gridNode);
    parentElement.appendChild(element);
    for (const childNode of gridNode.getChildNodes()) {
      renderGridNodes(childNode, element, config);
    }
  } else if (gridNode.isModule()) {
    let element;
    if (config.getModuleElementFromCacheByName) {
      const domCacheEntry = config.getModuleElementFromCacheByName(gridNode.getId());
      if (domCacheEntry) {
        element = domCacheEntry;
      }
    }
    if (!element) {
      element = findOrCreateDndAreaElement(gridNode);
    }
    parentElement.appendChild(element);
  }
}
function renderDndAreaLayer(treeRootNode, parentElement, config) {
  for (const sectionNode of treeRootNode.getChildNodes()) {
    const sectionElement = findOrCreateDndAreaElement(sectionNode);
    parentElement.appendChild(sectionElement);
    const sectionContentElement = sectionElement.lastElementChild;
    if (!sectionContentElement) {
      throw new Error('Section content element not found');
    }
    const containerNode = sectionNode.getChildNodes()[0];
    if (!containerNode) {
      throw new Error('Section child node not found');
    }
    renderGridNodes(containerNode, sectionContentElement, config);
  }
}

/**
 * Walks through trees and modies page DOM to match the tree structure
 * @param gridLayoutTrees
 * @param prevGridLayoutTrees
 * @param config
 */
export function renderDndAreasFromGridLayoutTrees(gridLayoutTrees, prevGridLayoutTrees, config = {}) {
  if (prevGridLayoutTrees) {
    forEachTree(prevGridLayoutTrees, (tree, key) => {
      const root = tree.getRootNode();
      DOM_LOOKUP_MAP[key] = {};
      addTreeElementsToLookupMap(root.getId(), root);
    });
  }

  // Iterates over the new tree and uses either uses DOM_LOOK_UP_MAP or creates new elements.
  forEachTree(gridLayoutTrees, tree => {
    const root = tree.getRootNode();
    let treeElement = getDndAreaElement(root.getId());
    treeElement = stripChildrenFromTreeNode(treeElement, root);
    renderDndAreaLayer(root, treeElement, config);
  });
}